import { useNavigate } from 'react-router-dom';

export const muvtechCategories = [
  {
    id: 1,
    type: 'iphonecase',
    path: '/muvtech/products-list',
    name: 'IPHONE CASES',
  },
  {
    id: 2,
    type: 'airpodscase',
    path: '/muvtech/products-list',
    name: 'AIRPODS CASES',
  },
  {
    id: 3,
    type: 'samsungcase',
    path: '/muvtech/products-list',
    name: 'SAMSUNG CASES',
  },
  {
    id: 4,
    type: 'samsungglass',
    path: '/muvtech/products-list',
    name: 'SAMSUNG GLASSES',
  },
  {
    id: 5,
    type: 'powerbank',
    path: '/muvtech/products-list',
    name: 'POWER BANKS',
  },
  {
    id: 6,
    type: 'ipadcase',
    path: '/muvtech/products-list',
    name: 'IPAD CASES',
  },
  {
    id: 7,
    type: 'ipadglass',
    path: '/muvtech/products-list',
    name: 'IPAD GLASSES',
  },
  {
    id: 8,
    type: 'wallcharger',
    path: '/muvtech/products-list',
    name: 'WALL CHARGERS',
  },
];

function MuvtechCate() {
  const navigate = useNavigate();
  return (
    <div className="category-buttons">
      {muvtechCategories.map((category) => (
        <button
          key={category?.id}
          className="category-button"
          onClick={() => navigate(`${category.path}/${category.type}`)}
        >
          {category?.name}
        </button>
      ))}
    </div>
  );
}

export default MuvtechCate;
